export class QuestionMediaInfo {
  name: string;
  url: string;
}
